module.exports = __webpack_public_path__ + "ca7db2a9b22e7cef40bc63937432343c.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/products/aa-crewneck-black.jpg
// module id = 823
// module chunks = 0